export const OIL_STORE_TYPE_MUTATION_KEYS = {
  CREATE: 'createOilStoreType',
  UPDATE: 'updateOilStoreType',
  DELETE: 'deleteOilStoreType',
  UPLOAD_LOGO: 'uploadOilStoreTypeLogo',
} as const;
